import { gql } from '@apollo/client'

import { RESTOCK_GROUP_FRAGMENT } from '../fragments/RestockGroupFragment'

export const GET_RESTOCK_GROUP = gql`
  query GetRestockGroup($id: ID!) {
    restockGroup(id: $id) {
      ...RestockGroup
    }
  }
  ${RESTOCK_GROUP_FRAGMENT}
`
